import client from '../../client'

export default {
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/CommonSelectCalender/CommonSelectCalenderFirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        nend: param.nend,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        hfkb: param.hfkb,
        sex:  param.sex,
        age:  param.age,
        opbrs: param.opbrs,
        opcds: param.opcds,
        optionJkcds: param.optionJkcds,
        trsq: param.trsq,
        my_ukno: param.my_ukno
      })

      var config = {
        method: 'post',
        url: url,
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })

    })
  },
  ChangeCalender: param => {
    return new Promise((resolve, reject) => {

      var url = '/api/CommonSelectCalender/CommonSelectCalenderChangeCalender'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        jgcd: param.jgcd,
        nend: param.nend,
        kscd: param.kscd,
        courseJkcd: param.courseJkcd,
        hfkb: param.hfkb,
        sex:  param.sex,
        age:  param.age,
        opbrs: param.opbrs,
        opcds: param.opcds,
        calenderYear:  param.calenderYear,
        calenderMonth: param.calenderMonth,
        trsq: param.trsq,
        my_ukno: param.my_ukno
      })

      var config = {
        method: 'post',
        url: url,
        data: data
      }

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })

    })
  },
}



// WEBPACK FOOTER //
// ./src/api/Common/SelectCalender/CommonSelectCalenderApi.js